import React from 'react';
import { View, Text, useWindowDimensions } from 'react-native';
import theme from '../../theme';
import SyncIcon from '@mui/icons-material/Sync';
import DataObjectIcon from '@mui/icons-material/DataObject';
import LinkIcon from '@mui/icons-material/Link';

const STEPS = [
  {
    Icon: SyncIcon,
    title: 'Stream live into BigQuery',
    body: 'Event data lands in to BigQuery in realtime, models are updated based on your needs.',
  },
  {
    Icon: DataObjectIcon,
    title: 'Parse the nested export',
    body: 'GA4\u2019s deeply nested event and parameter records are flattened and aggregated into clean, query-ready tables.',
  },
  {
    Icon: LinkIcon,
    title: 'Map to real customers',
    body: 'GA4\u2019s user_id is joined against your internal customer data, so LTV reflects actual revenue, not front-end sessions.',
  },
];

export default function GA4HowItWorks() {
  const { width } = useWindowDimensions();
  const isCompact = width < 700;

  return (
    <View
      style={{
        paddingHorizontal: isCompact ? theme.spacing.space5 : theme.spacing.space12,
        paddingVertical: isCompact ? theme.spacing.space10 : theme.spacing.space16 + 6,
        maxWidth: 1240,
        alignSelf: 'center',
        width: '100%',
        borderTopWidth: theme.borderWidth.thin,
        borderTopColor: theme.colors.borderSubtle,
      }}
    >
      <Text
        style={{
          fontFamily: theme.typography.fontDisplay,
          fontWeight: theme.typography.weight.regular,
          fontSize: isCompact ? theme.typography.size.lg : theme.typography.size['2xl'],
          letterSpacing: theme.trackingPx(theme.typography.size['2xl'], 'tight'),
          color: theme.colors.textPrimary,
          textAlign: 'center',
          marginBottom: theme.spacing.space10,
        }}
      >
        How it works
      </Text>

      <View style={{ flexDirection: isCompact ? 'column' : 'row', gap: theme.spacing.space8 }}>
        {STEPS.map((step, i) => {
          const Icon = step.Icon;
          return (
            <View key={i} style={{ flex: isCompact ? undefined : 1, alignItems: 'center' }}>
              <View
                style={{
                  width: 52,
                  height: 52,
                  borderRadius: theme.radii.lg,
                  backgroundColor: theme.colors.surfaceSunken,
                  borderWidth: theme.borderWidth.thin,
                  borderColor: theme.colors.borderDefault,
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginBottom: theme.spacing.space4,
                }}
              >
                <Icon style={{ fontSize: 22, color: theme.colors.accentPrimary }} />
              </View>
              <Text
                style={{
                  fontFamily: theme.typography.fontBody,
                  fontWeight: theme.typography.weight.semibold,
                  fontSize: theme.typography.size.md,
                  color: theme.colors.textPrimary,
                  textAlign: 'center',
                  marginBottom: theme.spacing.space2,
                }}
              >
                {step.title}
              </Text>
              <Text
                style={{
                  fontFamily: theme.typography.fontBody,
                  fontSize: theme.typography.size.sm,
                  color: theme.colors.textSecondary,
                  lineHeight: theme.lineHeightPx(theme.typography.size.sm, 'normal'),
                  textAlign: 'center',
                  maxWidth: 280,
                }}
              >
                {step.body}
              </Text>
            </View>
          );
        })}
      </View>
    </View>
  );
}
